<div class="toggle-switch">
  <input #checkbox type="checkbox" id="{{toggleId}}" [(ngModel)]="on" (change)="onToggle($event)" [disabled]="disabled"/>
  <label #label for="{{toggleId}}" [style.background-color]="labelColor">Toggle</label>
</div>
